export function textReveal() {
  const elements = document.querySelectorAll('.text-reveal');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      observer.unobserve(el);

      // Split met mask effect
      const split = SplitText.create(el, {
        type: "lines",
        mask: "lines",
        linesClass: "line"
      });

      gsap.fromTo(
        split.lines,
        { yPercent: 110 },
        {
          yPercent: 0,
          duration: 0.8,
          stagger: 0.08,
          ease: "power4.out"
        }
      );
    });
  }, { threshold: 0.1 });

  elements.forEach(el => observer.observe(el));
}
